import { render } from "./HeroiconsSolidDatabase.vue?vue&type=template&id=468bbc96"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDatabase.vue"]])

export default __exports__